import React, { useState } from "react";
import {
  Button,
  TextField,
  Typography,
  Container,
  CssBaseline,
  Paper,
  Box,
  Link,
} from "@mui/material";
import louca_logo from "../../../assets/Images/louca_logo.png";
import { useNavigate } from "react-router-dom";
// import { apiCallForgotPassword } from "../../../Core/Apicall"; // <-- your API call

export default function ForgetPage() {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState("");

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setLoading(true);
    setMessage("");

    try {
      // const res = await apiCallForgotPassword(data);
      // setMessage(res?.message || "Password reset link sent to your email.");
      setTimeout(() => {
        setMessage("Password reset link sent to your email."); // dummy response
        setLoading(false);
      }, 1000);
    } catch (error) {
      setMessage("Something went wrong. Please try again.");
      setLoading(false);
    }
  };

  return (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <Paper
        elevation={6}
        sx={{
          p: 4,
          mt: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <img src={louca_logo} alt="louca_logo" />
        <Typography component="h1" variant="h5">
          Forgot Password
        </Typography>
        <Typography variant="body2" sx={{ mt: 1, mb: 2, textAlign: "center" }}>
          Enter your email and we’ll send you a link to reset your password.
        </Typography>
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            autoFocus
            value={email}
            onChange={(e) => setEmail(e.target.value)}
          />
          {message && (
            <Typography
              variant="body2"
              color={message.includes("sent") ? "success.main" : "error"}
              sx={{ mt: 1 }}
            >
              {message}
            </Typography>
          )}
          <Button
            type="submit"
            fullWidth
            variant="contained"
            disabled={loading}
            sx={{ mt: 3, mb: 2, backgroundColor: "black" }}
          >
            {loading ? "Sending..." : "Send Reset Link"}
          </Button>
          <Link
            component="button"
            variant="body2"
            onClick={() => navigate("/admin/login")}
            style={{ color: "black",textDecoration:"none" }}
            sx={{ display: "block", textAlign: "center" }}
          >
            Back to Login
          </Link>
        </Box>
      </Paper>
    </Container>
  );
}
